webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_about__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_pages_about__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_blog__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_blog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_blog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_developer__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_developer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_developer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_imprint__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_imprint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_imprint__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_blog_infosophy__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_blog_infosophy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_blog_infosophy__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'About',
  component: __WEBPACK_IMPORTED_MODULE_2__components_pages_about___default.a
}, {
  path: '/blog',
  name: 'Blog',
  component: __WEBPACK_IMPORTED_MODULE_3__components_pages_blog___default.a
}, {
  path: '/blog/infosophy',
  name: 'Infosophy',
  hideFromMenu: true,
  component: __WEBPACK_IMPORTED_MODULE_6__components_pages_blog_infosophy___default.a
}, {
  path: '/developer',
  name: 'Developer',
  component: __WEBPACK_IMPORTED_MODULE_4__components_pages_developer___default.a
}, {
  path: '/imprint',
  name: 'Imprint',
  component: __WEBPACK_IMPORTED_MODULE_5__components_pages_imprint___default.a
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes,
  linkActiveClass: 'nav-link--active'
}));

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  "data-v-2af82f82",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index_js__ = __webpack_require__(16);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('navmain', __webpack_require__(28));

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router_index_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_index__ = __webpack_require__(16);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navmain',
  data: function data() {
    return {
      pages: __WEBPACK_IMPORTED_MODULE_0__router_index__["a" /* default */].options.routes
    };
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about'
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);



var posts = [{
  name: 'Infosophy',
  path: '/blog/infosophy',
  abstract: 'What informatics and philosophy can learn from each other.',
  tags: ['informatics', 'philosophy']
}];
var tags = [];
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(posts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var post = _step.value;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(post.tags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var tag = _step2.value;

        if (tags.indexOf(tag) === -1) {
          tags.push(tag);
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'blog',
  data: function data() {
    return {
      posts: posts,
      tags: tags,
      activeTag: null,
      selectTag: function selectTag(tag) {
        if (this.activeTag === tag) {
          this.activeTag = null;
        } else {
          this.activeTag = tag;
        }
      }
    };
  }
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-infosophy'
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'developer'
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'imprint'
});

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(71)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  "data-v-31dfc54f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  "data-v-29aa6af7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navmain'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('h1', [_vm._v("Imprint")]), _vm._v(" "), _c('p', [_vm._v("\n    This site is made and run by Merten Hanisch"), _c('br'), _vm._v("\n    Contact:\n    "), _c('a', {
    attrs: {
      "href": "mailto:merten.hanisch@gmail.com"
    }
  }, [_vm._v("merten.hanisch@gmail.com")])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('h2', [_vm._v("Infosophy")]), _vm._v(" "), _c('p', [_c('time', [_vm._v("2017-04-25")])]), _vm._v(" "), _c('p', [_vm._v("\n    All sciences originate from philosophy. I like to explain it this way, with a wink: Philosophy used to be the\n    only science, and it was full of unanswered questions. Whenever a theoretical system could be established or a\n    host of questions could be answered satisfactory, philosophers lost their interest in it, and so it became a\n    science of itself."), _c('br'), _vm._v("\n    Now, informatics or computer sciences started naive (which is good) and then figured, it was hard to grasp a\n    programme, when it became more complicated. So the object-oriented programming was thought up, dividing parts of\n    code into 'objects' for the sole purpose of making it easier to understand for developers, since (against common\n    belief) developers are humans and we understand our world in objects."), _c('br'), _vm._v("\n    Objects in programming languages are defined by classes, a concept very close to Plato's Ideology. It is a\n    marvelous thing for a philosopher to see a model world where the Ideology is not only a theoretical system that\n    tries to explain how we perceive the world, but that actually works as defined by it. Classes define properties\n    and methods, which is a good system to work with objects in code. In most languages these are stable, in some\n    (like JavaScript) the object can have new properties and methods, after they have been created from their class\n    ('my dog can do a trick, no other dog can do') - which we can find in the real world as well and is easy to\n    understand. From a philosopher's point of view, this is interesting and it is enriching to have a look at\n    computer sciences."), _c('br'), _vm._v("\n    But philosophers have been thinking about objects for about 2500 years, surely they have come up with ideas\n    about them, that computer science could find useful as well? Let's have a look at Aristoteles\n    "), _c('i', {
    attrs: {
      "title": "or categories"
    }
  }, [_vm._v("Decem Genera")]), _vm._v("! Aristoteles looked at objects and found ten different\n    "), _c('i', {
    attrs: {
      "title": "kindly excuse my rough translation of those"
    }
  }, [_vm._v("attributes")]), _vm._v(" inherent to them:\n  ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Substance")]), _vm._v(" "), _c('li', [_vm._v("Quantity")]), _vm._v(" "), _c('li', [_vm._v("Quality")]), _vm._v(" "), _c('li', [_vm._v("Relation")]), _vm._v(" "), _c('li', [_vm._v("Location")]), _vm._v(" "), _c('li', [_vm._v("Time")]), _vm._v(" "), _c('li', [_vm._v("State")]), _vm._v(" "), _c('li', [_vm._v("Properties")]), _vm._v(" "), _c('li', [_vm._v("Acting")]), _vm._v(" "), _c('li', [_vm._v("Suffering")])]), _vm._v(" "), _c('p', [_vm._v("\n    Example:"), _c('br'), _vm._v("\n    Sokrates is of the Substance 'human', he has a Quantity of 70kg and another Quantity of 1.70m height. One of his\n    Qualities is, that he knows how to speak. One of his Relations is, that he is the teacher of Plato, another that\n    he lived about 2500 years before you. His Location would be Athens (best specified at a given point in time, I\n    guess). His Time would be 469 to 399 before our time. His State could be 'sitting in a chair'. His Properties:\n    wearing a toga and sandals. His Acting could be drinking a cup of poison hemlock. His Suffering: being poisoned.\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    'Substance' could be translated as the class of the object, and while properties are pretty much\n    self-explanatory, the 'acting' can be seen as the methods of a class. Can we find other categories, that are\n    already in objects of some programming languages or is a programming language thinkable, that implements the\n    other categories? Would we gain anything by implementing them?\n  ")]), _vm._v(" "), _c('p', [_vm._v("\n    I'll stop here to ponder on this question. Let's not answer this too fast, lest the question will be no part of\n    philosophy, again.\n  ")])])
}]}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('nav', [_c('router-link', {
    staticClass: "nav-link nav-link--normal",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Merten Hanisch")]), _vm._v(" "), _c('span', {
    staticClass: "hide-mobile"
  }, [_vm._v("| ")]), _vm._v(" "), _c('ul', _vm._l((_vm.pages), function(page) {
    return (!page.hideFromMenu) ? _c('li', [_c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": page.path,
        "exact": ""
      }
    }, [_vm._v(_vm._s(page.name))]), _vm._v(" "), _c('span', [_vm._v("| ")])], 1) : _vm._e()
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-block"
  }, [_c('h1', [_vm._v("Blog")]), _vm._v(" "), _c('p', [_vm._v("Filter by tags:")]), _vm._v(" "), _c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('span', {
      staticClass: "tag",
      class: [tag === _vm.activeTag ? 'tag--active' : ''],
      on: {
        "click": function($event) {
          _vm.selectTag(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }))]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
    return (!_vm.activeTag || post.tags.indexOf(_vm.activeTag) >= 0) ? _c('div', {
      staticClass: "content-block"
    }, [_c('router-link', {
      attrs: {
        "to": post.path
      }
    }, [_c('h3', [_vm._v(_vm._s(post.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(post.abstract))])])], 1) : _vm._e()
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-block"
  }, [_c('h1', [_vm._v("Developer")]), _vm._v(" "), _c('p', [_vm._v("\n      My core skills are:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("JavaScript")]), _vm._v(" "), _c('li', [_vm._v("HTML5")]), _vm._v(" "), _c('li', [_vm._v("git")]), _vm._v(" "), _c('li', [_vm._v("NodeJS")]), _vm._v(" "), _c('li', [_vm._v("PostCSS, Sass or SCSS")]), _vm._v(" "), _c('li', [_vm._v("gulp")]), _vm._v(" "), _c('li', [_c('i', {
    attrs: {
      "title": "a way of structuring large scale CSS"
    }
  }, [_vm._v("BEM")])]), _vm._v(" "), _c('li', [_vm._v("Jasmine / Karma")]), _vm._v(" "), _c('li', [_vm._v("AngularJS")]), _vm._v(" "), _c('li', [_vm._v("Silverstripe (a PHP framework and CMS)")]), _vm._v(" "), _c('li', [_vm._v("Database design")])]), _vm._v(" "), _c('p', [_vm._v("\n      I also like to use D3.js for data visualization, write JS in ES6 and then transpile it, make fast backends with\n      PHP, create thorough requirements engineering, keep code clean, do code reviews, use VueJS or React and Phaser.io.\n      When it comes to template engines, the simpler, the better - that is why I like Handlebars.\n      I also still know my way around in mercurial and the ionic framework. I also have experience in moving projects\n      forward from legacy frameworks like bower or grunt to more modern technologies. I am comfortable with\n      test-driven development and find that code reviews always make a project better.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('h2', [_vm._v("My work experience as a developer:")]), _vm._v(" "), _c('h3', [_c('time', [_vm._v("01/2018 - today")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Frontend Developer at Netzkontor Nord, Flensburg")]), _c('br'), _vm._v("\n      Developing and maintaining business software for multiple public services, that offer glass fiber connections to their\n      communities. Glass fiber is an incredibly interesting technology. In the state of Schleswig-Holstein it has huge momentum,\n      so there is a demand for modern applications to handle customer relations and interfaces to telecommunication systems.\n      The superstructure is driven by many public services, big and small, instead of only one or two big players, which creates\n      great opportunities for a company that is supporting all of these clients with knowledge, planning and software.\n    ")]), _vm._v(" "), _c('h3', [_c('time', [_vm._v("02/2016 - 12/2017")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Frontend Developer at PublicisPixelpark, Berlin")]), _c('br'), _vm._v("\n      Leading the frontend team for a large project. The backend is an Adobe Experience Manager application with\n      various services connected. It is a challenging and very modern project. My goal was to keep the frontend\n      maintainable, fast, sturdy and beautiful. Modularization was the key component in accomplishing that. Neat\n      documentation and optimized processes helped in delivering on time and making our client happy.\n    ")]), _vm._v(" "), _c('h3', [_c('time', [_vm._v("10/2014 - 01/2016")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Frontend Developer at eThinking, Berlin")]), _c('br'), _vm._v("\n      I helped this startup, consisting of very skilled Java developers, to make administrative webapps for big media\n      clients and websites and apps for their publications. Custom realtime analytics tools for millions of page\n      impression a day, managing thousands of assets in a simple way for editors and building a modular news app are\n      just some of the goals we accomplished together. Our fast and flexible approaches made sure we always had a way\n      to tackle upcoming challenges, provide growth to the company and still had the time to build open source\n      solutions, while doing so. We also built a push notification service, that challenges even the fastest big\n      players in the world.\n    ")]), _vm._v(" "), _c('h3', [_c('time', [_vm._v("07/2014 - today")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Freelance Developer")]), _c('br'), _vm._v("\n      A few happy clients trust me with their whole projects, for multiple years now. Others seek short-term aid and\n      consultation from me. I am always excited to hear about your project.\n    ")]), _vm._v(" "), _c('h3', [_c('time', [_vm._v("08/2012 - 09/2014")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Developer at ennit interactive, Kiel")]), _c('br'), _vm._v("\n      Building beautifully and individually designed websites for many clients, big and small, in the hotel industry\n      and web shops. I crafted professional and easy-to-use CMSes to be used by the clients' staff and tailored to\n      their editing and marketing needs. I was also deeply involved in planning a custom architecture and running the\n      technical project management for an online shopping solution of a european market leader, who today surpasses\n      it's competitors.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("\n      If you would like to get an even more detailed look at my career, have a look at my\n      "), _c('a', {
    attrs: {
      "href": "https://www.xing.com/profile/Merten_Hanisch",
      "target": "_blank"
    }
  }, [_vm._v("Xing profile")]), _vm._v("."), _c('br'), _vm._v("\n      Or ask me any questions you have directly:\n      "), _c('a', {
    attrs: {
      "href": "mailto:merten.hanisch@gmail.com"
    }
  }, [_vm._v("merten.hanisch@gmail.com")]), _vm._v(".\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('p', [_vm._v("\n      Also check out my side-projects as a game developer at "), _c('a', {
    attrs: {
      "href": "http://mortal.host",
      "target": "_blank"
    }
  }, [_vm._v("Mortal Host")]), _vm._v(".\n    ")])])])
}]}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "avatar__bg",
    attrs: {
      "d": "M12 24A12 12 0 0 1 0 12 12 12 0 0 1 12 0a12 12 0 0 1 12 12 12 12 0 0 1-12 12z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#FFE1A4",
      "cx": "6.2",
      "cy": "12.1",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#FFE1A4",
      "cx": "17.8",
      "cy": "12.1",
      "r": "1.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFE1A4",
      "d": "M6.2 8.2H18v8.7H6.2z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#50360e",
      "d": "M18.5 16.3c0-.5-.2-.9-.5-1.2V9.9c-.8 0-1.5.7-1.5 1.5v2.4c0 .5-.3.7-.7.7H8.4c-.5 0-.7-.3-.7-.7v-2.4c0-.8-.7-1.5-1.5-1.5v4.9c-.5.3-.7.8-.7 1.3 0 .8.6 1.5 1.4 1.7v.1c0 1.2 1 2.2 2.2 2.2l.7-.1c.4.7 1.1 1.3 2 1.3a2 2 0 0 0 1.9-1.2c.3.2.7.3 1.1.3a2 2 0 0 0 2-2v-.3c.9 0 1.7-.8 1.7-1.8z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#14243a",
      "d": "M12 17.6c.7 0 1.2-.5 1.4-1.1.1-.2-.1-.5-.4-.5h-2.1c-.2 0-.5.2-.4.5.3.8.8 1.1 1.5 1.1z"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#FFE1A4",
      "cx": "12",
      "cy": "14",
      "r": "1.2"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#14243a",
      "cx": "9.9",
      "cy": "12.6",
      "r": ".6"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "fill": "#14243a",
      "cx": "14.1",
      "cy": "12.6",
      "r": ".6"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#F44542",
      "d": "M17.5 9h-11v-.8c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5V9z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#db3f3b",
      "d": "M17.9 9H6.1a.9.9 0 0 1-.8-.8c0-.5.4-.8.8-.8h11.6c.5 0 .8.4.8.8.1.5-.2.8-.6.8z"
    }
  })])]), _vm._v(" "), _c('h1', [_vm._v("About me")]), _vm._v(" "), _c('p', [_vm._v("\n      I'm a developer living in Flensburg, Germany. The purpose of this website is to present my projects and some thoughts. Here is a short curriculum vitae: ")]), _vm._v(" "), _c('p', [_vm._v("\n      I was born in Flensburg, Germany, in 1983."), _c('br'), _vm._v(" After school I studied philosophy, psychology and German literature in Kiel, while working in IT-related jobs. After graduating as a\n      "), _c('i', {
    attrs: {
      "title": "That was the german equivalent to the Master of Arts degree, back then."
    }
  }, [_vm._v("Magister Artium")]), _vm._v(" with a thesis about\n      "), _c('i', {
    attrs: {
      "title": "To talk in the first person a lot"
    }
  }, [_vm._v("Egotism")]), _vm._v(", I was working as a teacher, biographer and lector. Then I decided I wanted to start learning something new again, so I returned to my old passion, the IT. I became a developer, focussing on frontend technologies. I love learning new things, so to this day I am very happy with my decision to make my living within a field in which new ideas and concepts emerge all the time. If you would like to see if I am suited for your project, please head over to the "), _c('router-link', {
    attrs: {
      "to": "/developer"
    }
  }, [_vm._v("developer section")]), _vm._v(".\n    ")], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      You are welcome to get a more detailed look at my career on my\n      "), _c('a', {
    attrs: {
      "href": "https://www.xing.com/profile/Merten_Hanisch",
      "target": "_blank"
    }
  }, [_vm._v("Xing profile")]), _vm._v("! ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-block"
  }, [_c('h2', [_vm._v("Other than that...")]), _vm._v(" "), _c('p', [_vm._v("\n      ... who doesn't like to do something different from time to time? Like ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://mortal.host",
      "target": "_blank"
    }
  }, [_vm._v("Developing games")])]), _vm._v(" "), _c('li', [_vm._v("Getting away from technology and living in a\n        "), _c('a', {
    attrs: {
      "href": "http://valsgaard.de/"
    }
  }, [_vm._v("viking village")]), _vm._v(" every now and then\n      ")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/channel/UCqJToZ8hMUVA6Hrgl_jqfKA",
      "target": "_blank"
    }
  }, [_vm._v("Playing the\n          concertina in dashing costumes")])])])])
}]}

/***/ })
],[29]);


// WEBPACK FOOTER //
// static/js/app.a778e780e716967f45d9.js